import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    tap((event: any) => {
      if (event?.body?.errorCode === '999999' && !router.url.startsWith('/salary-confirmation')) {
        router.navigateByUrl('/login');
      }
    })
  );
};
